/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  main: {
    padding: '20px 0',
  },
  container: {
    maxWidth: '1184px',
  },

  extraComponentContainer: {
    paddingRight: '20px',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '10px',
      paddingLeft: '10px',
    },
  },
  cancelApplicationbtn: {
    transition: 'none',
    textTransform: 'none',
    color: '#DF2C2C',
    fontSize: '14px',
    fontWeight: 600,
    padding: 0,
    marginTop: 15,
    '& img': {
      marginRight: '8px',
      width: '14px',
    },
    '&:hover': {
      background: 'transparent',
    },
  },
  paperCardFrame: {
    borderRadius: '0px',
    marginBottom: '16px',
  },
  TerminateBtn: {
    fontSize: '16px',
    color: '#342D3D',
    height: '48px',
    minWidth: '151px',
    border: '1px solid #342D3D',
    textTransform: 'none',
    marginRight: '16px',
    borderRadius: '10px',
    transition: 'none',
    '&:hover': {
      background: '#342D3D',
      color: '#fff',
    },
  },
  innerModalAccept: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '0',
      top: '0',
    },
    '& h1': {
      marginBottom: '24px',
      fontSize: '20px',
    },
    '& h2': {
      marginBottom: '28px',
      fontWeight: '400',
      fontSize: '16px',
    },
  },
  crossIconimg: {
    cursor: 'pointer',
  },
  modalAccptBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '48px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '10px',
    '&:hover': {
      background: '#c02b42',
    },
  },
  innerCardGrid: {},
  titleHead: {
    background: theme.palette.primary.grey,
    display: 'flex',
    padding: '16px 24px',
    borderRadius: '10px',
    '& h2': {
      color: theme.palette.primary.acscent,
      marginBottom: '0',
      fontSize: '20px',
      fontWeight: '600',
    },
  },
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
  },
  warningmassage: {
    background: theme.palette.primary.infoBlueLight,
    display: 'inline-flex',
    alignItems: 'center',
    padding: '12px',
    borderBottom: '1px solid #DBDEE6',
    '& p': {
      fontSize: '12px',
    },
    '& img': {
      marginRight: '8px',
    },
  },

  breadcrumbsHolder: {
    padding: '0 0 12px 0',
    display: 'flex',
    alignItems: 'center',
    '& $serviceid': {
      marginLeft: 'auto',
      color: '#8C9099',
      fontSize: '14px',
      '& strong': {
        fontWeight: '600',
      },
    },
  },
  serviceid: {},
  breadcrumbs: {
    fontSize: '12px',
    '& li': {
      padding: '0',
      border: '0',
    },
    '& a': {
      color: theme.palette.primary.adgmGreen,
      textDecoration: 'none',
      '& svg': {
        fontSize: '18px',
      },
    },
    '& $activelink': {
      color: theme.palette.primary.darkGrey,
    },
  },
  activelink: {},
  mobileTitlehead: {
    borderBottom: `3px solid ${theme.palette.primary.borderColor}`,
    padding: '0 15px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& a': {
      color: theme.palette.primary.acscent,
      padding: '7px 0',
      fontWeight: '500',
      display: 'block',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
      '& img': {
        marginRight: '13px',
      },
    },
    '& $grayArea': {
      background: theme.palette.primary.grey,
      color: theme.palette.primary.darkGrey,
      '& p': {
        fontSize: '12px',
      },
    },
  },
  propertyItemContainer: {
    display: 'flex',
  },
  plotNumberContainer: {
    paddingLeft: '15px',
  },
  terminateBtnMobile: {
    minWidth: 'auto',
    border: '0',
    padding: '0',
    background: theme.palette.primary.white,
  },

  // paymentDetails
  paymentDetailsGrid: {
    '& > $paymentDetailContainer:not(:first-of-type)': {
      borderTop: `8px solid ${theme.palette.primary.borderColor}`,
    },
    '& $paymentDetailItemContainer:not(:first-of-type)': {
      borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    },
  },
  paymentDetailContainer: {},
  paymentDetailItemContainer: {
    padding: '20px 24px',
    borderBottom: '1px solid #EBEEF3',
  },
  paymentDetailItem: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& > span': {
      fontSize: '16px',
      color: theme.palette.primary.adgmBlack,
      fontWeight: '600',
      maxWidth: '60%',
    },
  },
  totalPaymentDetailItemContainer: {},
  paymentDetailSubItemsContainer: {
    marginTop: '10px',
  },
  subItemLabel: {},
  paymentDetailSubItem: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '&:not(:first-of-type)': {
      marginTop: '8px',
    },
    '& > span': {
      fontSize: '14px',
      color: theme.palette.primary.adgmBlack,
      fontWeight: '400',
    },
    '& > span:nth-child(2)': {
      whiteSpace: 'nowrap',
    },
    '& $subItemLabel': {
      maxWidth: '70%',
    },
  },
  paymentDetailsBtnContainer: {
    padding: '24px',
    borderTop: `3px solid #D5D6D7`,
  },

  // paymentMethod
  paymentMethodFormControl: {
    display: 'block',
  },
  paymentMethodRadioGroup: {
    padding: '24px !important',
    color: theme.palette.secondary.light,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    '&:not(:first-of-type)': {
      borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    },
    '& input:checked + div': {
      color: '#000000',
    },
    '& svg': {
      height: '28px',
      width: '28px',
    },
    '&:first-child': {
      paddingTop: '0',
    },
  },
  paymentMethodRadioBtn: {
    padding: '0',
  },
  paymentMethodRadioLabel: {
    flex: '1',
    marginLeft: '18px',
    display: 'flex',
    flexDirection: 'column',
  },

  paymentMethodRadioLabelDisabled: {
    opacity: 0.4,
  },

  paymentMethodRadioTitleWithIcon: {
    '& img': {
      marginRight: '6px',
    },
    '& span': {
      color: theme.palette.primary.adgmBlack,
      fontWeight: '500',
      fontSize: '18px',
      lineHeight: '26px',
    },
  },
  paymentMethodRadioAmount: {
    color: theme.palette.primary.darkGrey,
    fontWeight: '400',
    marginTop: '10px',
  },

  disableWalletMessageContainer: {
    marginTop: '16px',
    width: '100%',
    alignItems: 'flex-start !important',
    '& span': {
      color: `${theme.palette.primary.adgmBlack} !important`,
    },
  },

  terminateBtn: {
    width: '100%',
    color: theme.palette.primary.adgmBlack,
    background: theme.palette.primary.white,
    fontWeight: '600',
    fontSize: '16px',
    textTransform: 'capitalize',
    lineHeight: '24px',
    padding: '18px 16px',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,

    '& > .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        marginRight: '8px',
      },
    },
  },
  commonRedBtn: {
    width: '100%',
    color: theme.palette.primary.white,
    background: theme.palette.primary.main,
    fontWeight: '600',
    fontSize: '16px',
    textTransform: 'capitalize',
    lineHeight: '24px',
    padding: '15px 16px',
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },

  '@media (max-width: 768px)': {
    container: {
      padding: '0',
    },
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
  },
  '@media (max-width: 960px)': {
    // mdDown
    titleHead: {
      padding: '12px 16px',
      '& h2': {
        fontSize: '16px',
      },
    },

    gridContainer: {
      marginBottom: '40px',
    },
    propertyContainer: {
      padding: '0.65em 2em',
    },

    // paymentDetails
    paymentDetailItemContainer: {
      padding: '20px 16px',
    },

    // paymentMethod
    paymentMethodRadioGroup: {
      padding: '24px 16px !important',
      alignItems: 'center',
    },
    paymentMethodRadioLabel: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginLeft: '12px',
    },
    paymentMethodRadioTitleWithIcon: {
      '& img': {
        marginRight: '6px',
      },
      '& span': {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
      },
    },
    paymentMethodRadioAmount: {
      fontWeight: '500',
      fontSize: '12px',
      marginTop: '0',
      '& > span:first-of-type': {
        display: 'none',
      },
    },

    // terminateBtn
    terminateBtnContainer: {
      display: 'none',
    },
  },
  [theme.breakpoints.down('sm')]: {
    paymentHead: {
      fontSize: '14px',
      lineHeight: '21px',
    },
    innerModalAccept: {
      '& $crossIconimg': {
        right: '-4px',
      },
      '& h1': {
        marginBottom: '20px',
        fontSize: '16px',
      },
      '& h2': {
        marginBottom: '18px',
        fontSize: '14px',
      },
      '& hr': {
        backgroundColor: '#CED1D6',
      },
    },
    TerminateBtn: {
      fontSize: '14px',
      minWidth: '100px',
      marginRight: '16px',
    },
    modalAccptBtn: {
      fontSize: '14px',
      minWidth: '100px',
    },
    applicationHeader: {
      '& p': {
        fontSize: '12px',
        margin: '15px',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    applicationHeader: {
      '& h1, & p': {
        fontWeight: 600,
      },
      '& h1': {
        color: theme.palette.primary.darksky100,
        fontSize: '32px',
        fontWeight: 500,
      },
      '& p': {
        fontSize: '18px',
      },
    },
  },
  TitleV2: {
    fontWeight: '600',
    fontSize: '16px',
  },
  headerV2: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '& img': {
      width: '75px',
    },
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
      marginBottom: '10px',
      '& img': {
        width: '40px',
      },
    },
  },
  headerContentV2: {
    display: 'flex',
    flexDirection: 'column',
    '& >h1': {
      fontSize: '24px',
      fontWeight: '600',
    },
    '& > img': {
      width: '75px',
    },
    [theme.breakpoints.down('sm')]: {
      '& >h1': {
        fontSize: '12px',
        fontWeight: '500',
      },
      '& >p': {
        fontSize: '12px',
        fontWeight: '500',
      },
    },
  },
});

export default styles;
